module.exports = __webpack_public_path__ + "static/media/Morganite-Medium.35042211.ttf";